import styled from "@emotion/styled";
import theme from "@styles/theme";
import { alpha } from "@mui/material";

const StyledCategoryTreeDiv = styled.div`
  & .tree-item {
    width: 100%;

    &.tree-item-selected > *:not(.btn-dropdown-toolbar) {
      background-color: ${alpha(theme.palette.primary[100], 0.2)} !important;
      color: ${theme.palette.primary.main} !important;
    }

    &:hover {
      &:not(.tree-item-selected) > *:not(.btn-dropdown-toolbar) {
        background-color: ${alpha(theme.palette.secondary.main, 0.04)} !important;
      }

      &.tree-item-selected > *:not(.btn-dropdown-toolbar) {
        background-color: ${alpha(theme.palette.primary[100], 0.2)} !important;
      }
    }

    & .tree-item-label {
      flex: 1;
    }
  }
`;

export default StyledCategoryTreeDiv;
